import React, { useEffect, useState } from 'react';

const ApplicantDemographics = ({ fieldValues }) => {
    const [state, setState] = useState({});

    const yesNoFields = [
        // Borrower
        "4193", "4194", "4195", // Sex
        "4245", "4211", "4210", "4144", "4145", "4146", "4147", // Ethnicity
        "4205", "1524", "1525", "4148", "4149", "4150", "4151", "4152", "4153", "4154", 
        "1526", "1527", "4155", "4156", "4157", "4158", "1528", // Race
      
        // Co-Borrower
        "4197", "4198", "4199", // Sex (Co-Borrower)
        "4248", "4214", "4213", "4159", "4160", "4161", "4162", // Ethnicity (Co-Borrower)
        "4206", "1532", "1533", "4163", "4164", "4165", "4166", "4167", "4168", "4169",
        "1534", "1535", "4170", "4171", "4172", "4173", "1536" // Race (Co-Borrower)
      ];

      

      useEffect(() => {
        const initialState = {};
        Object.keys(fieldValues).forEach((key) => {
            if (yesNoFields.includes(key)) {
                initialState[key] = fieldValues[key] === 'Y' ? true : fieldValues[key] === 'N' ? false : false;
            } else {
                initialState[key] = fieldValues[key] || '';
            }
        });
        setState(initialState);
    }, [fieldValues]);
    

    const handleCheckboxChange = (fieldId, groupIds, isChecked) => {
        const newState = { ...state, [fieldId]: isChecked };  // Directly store true/false

        // Exclusive group logic
        const isNowDoNotWish = isChecked;

        if (groupIds?.length > 0) {
            groupIds.forEach(id => {
                if (id !== fieldId) {
                    newState[id] = isNowDoNotWish ? false : newState[id];  // Deselect others if exclusive
                }
            });
        }

        // If selecting anything else, uncheck 'I do not wish'
        if (!isNowDoNotWish) {
            groupIds?.forEach(id => {
                if (id !== fieldId && (id.endsWith('5') || id.endsWith('8') || id.endsWith('6'))) {
                    newState[id] = false;
                }
            });
        }

        setState(newState);
    };

    const renderCheckbox = (label, fieldId, group = []) => (
        <label className="checkbox-label">
            <input
                type="checkbox"
                className="checkbox-accent"
                id={`field-${fieldId}`}
                name={`field-${fieldId}`}
                checked={state[fieldId] === true}
                onChange={(e) => handleCheckboxChange(fieldId, group, e.target.checked)}
            />
            {label}
        </label>
    );

    const renderTextField = (label, fieldId) => (
        <div className="mb-2 mt-1">
            <label className="form-label">{label}</label>
            <input
                className="form-input"
                type="text"
                id={`field-${fieldId}`}
                value={state[fieldId] || ''}
                onChange={(e) => setState(prev => ({ ...prev, [fieldId]: e.target.value }))}
            />
        </div>
    );

    const demographicSection = (title, ids) => (
        <div>
            <h3 className="subsection-title1">{title} <span className="italic">(continued)</span></h3>

            {/* Sex */}
            <div className="mb-4">
                <label className="form-label">Sex:</label>
                <div className="flex flex-col gap-2">
                    {[ids.sex.female, ids.sex.male, ids.sex.doNotWish].map(id => {
                        const label = id.endsWith('3') || id.endsWith('7') ? 'Female' :
                            id.endsWith('4') || id.endsWith('8') ? 'Male' : 'I do not wish to provide this information';
                        return renderCheckbox(label, id, [ids.sex.female, ids.sex.male, ids.sex.doNotWish]);
                    })}
                </div>
            </div>

            {/* Ethnicity */}
            <div className="mb-4">
                <label className="form-label">Ethnicity:</label>
                <div className="flex flex-col gap-2">
                    {[ids.ethnicity.doNotWish, ids.ethnicity.notHispanic, ids.ethnicity.hispanic].map(id =>
                        renderCheckbox(
                            id === ids.ethnicity.doNotWish ? 'I do not wish to provide this information' :
                                id === ids.ethnicity.notHispanic ? 'Not Hispanic or Latino' : 'Hispanic or Latino',
                            id,
                            [ids.ethnicity.doNotWish, ids.ethnicity.notHispanic, ids.ethnicity.hispanic]
                        )
                    )}
                    <div className="grid grid-cols-2 gap-2 pl-4">
                        {[ids.ethnicity.mexican, ids.ethnicity.puerto, ids.ethnicity.cuban, ids.ethnicity.hispanic2].map(id => {
                            const labels = {
                                [ids.ethnicity.mexican]: 'Mexican',
                                [ids.ethnicity.puerto]: 'Puerto Rican Other',
                                [ids.ethnicity.cuban]: 'Cuban',
                                [ids.ethnicity.hispanic2]: 'Hispanic or Latino'
                            };
                            return renderCheckbox(labels[id], id, [ids.ethnicity.doNotWish]);
                        })}
                    </div>
                    {renderTextField('Print origin:', ids.ethnicity.print)}
                    <label className="form-label text-xs italic">
                        For example: Argentinean, Colombian, Dominican, Nicaraguan, Salvadoran,
                        Spaniard, and so on.
                    </label>
                </div>
            </div>

            {/* Race */}
            <div className="mb-4">
                <label className="form-label">Race: <span className="italic text-xs">(Check one or more)</span></label>
                <div className="space-y-2">
                    {renderCheckbox('I do not wish to provide this information', ids.race.doNotWish, [
                        ids.race.americanIndian, ids.race.black, ids.race.white, ids.race.asian,
                        ids.race.nativeHawaiian, ...ids.race.asianGroup, ...ids.race.pacificGroup
                    ])}
                    {renderCheckbox('American Indian or Alaska Native', ids.race.americanIndian)}
                    {renderTextField('Print name of enrolled or principal tribe:', ids.race.tribe)}

                    {renderCheckbox('Asian', ids.race.asian)}
                    {/* Asian group checkboxes with labels */}
                    <div className="grid grid-cols-3 gap-2">
                        {[
                            { id: ids.race.asianGroup[0], label: "Asian Indian" },
                            { id: ids.race.asianGroup[1], label: "Chinese" },
                            { id: ids.race.asianGroup[2], label: "Filipino" },
                            { id: ids.race.asianGroup[3], label: "Japanese" },
                            { id: ids.race.asianGroup[4], label: "Korean" },
                            { id: ids.race.asianGroup[5], label: "Vietnamese" }
                        ].map(({ id, label }) => (
                            <label key={id} className="checkbox-label">
                                <input
                                    type="checkbox"
                                    className="checkbox-accent"
                                    name={`field-${id}`}
                                    id={`field-${id}`}
                                    checked={state[id] === true}
                                    onChange={(e) => handleCheckboxChange(id, [ids.race.doNotWish], e.target.checked)}
                                />
                                {label}
                            </label>
                        ))}
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                        {renderCheckbox('Other Asian', ids.race.otherAsian)}
                        {renderTextField('Print race:', ids.race.print1)}
                        <label className="form-label text-xs italic col-span-2">
                            For example: Hmong, Laotian, Thai, Pakistani, Cambodian, and so on
                        </label>
                    </div>

                    {renderCheckbox('Black or African American', ids.race.black)}
                    {renderCheckbox('Native Hawaiian or Other Pacific Islander', ids.race.nativeHawaiian)}
                    {/* Pacific group checkboxes with labels */}
                    <div className="grid grid-cols-3 gap-2">
                        {[
                            { id: ids.race.pacificGroup[0], label: "Native Hawaiian" },
                            { id: ids.race.pacificGroup[1], label: "Guamanian or Chamorro" },
                            { id: ids.race.pacificGroup[2], label: "Samoan" }
                        ].map(({ id, label }) => (
                            <label key={id} className="checkbox-label">
                                <input
                                    type="checkbox"
                                    className="checkbox-accent"
                                    name={`field-${id}`}
                                    id={`field-${id}`}
                                    checked={state[id] === true}
                                    onChange={(e) => handleCheckboxChange(id, [ids.race.doNotWish], e.target.checked)}
                                />
                                {label}
                            </label>
                        ))}
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                        {renderCheckbox('Other Pacific Islander', ids.race.otherPacific)}
                        {renderTextField('Print race:', ids.race.print2)}
                        <label className="form-label text-xs italic col-span-2">
                            For example: Fijian, Tongan, and so on.
                        </label>
                    </div>
                    {renderCheckbox('White', ids.race.white)}
                </div>
            </div>
        </div>
    );

    return (
        <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9] mb-3">
            <div className="text-[var(--slate-grey-2)] text-sm pt-4 pb-4 px-4">
                The purpose of collecting this information is to help ensure that all applicants are treated fairly and that the housing needs
                of communities and neighborhoods are being fulfilled. For residential mortgage lending, Federal law requires that we ask
                applicants for their demographic information (ethnicity, race, and sex) in order to monitor our compliance with equal credit
                opportunity, fair housing, and home mortgage disclosure laws. You are not required to provide this information but are
                encouraged to do so. You may select one or more designations for “Ethnicity” and one or more designations for “Race”.
            </div>
            <div className="text-[var(--slate-grey-2)] text-sm px-4 pb-4">
                The law provides that we may not discriminate on the basis of this information, or on whether you choose to provide it.
                However, if you chose not to provide the information and you have made this application in person, Federal regulations
                require us to note your ethnicity, race, and sex on the basis of visual observation or surname. If you do not wish to provide
                some or all of this information, please check below.
            </div>
            <div className="grid md:grid-cols-2 gap-6 p-4">
                <div>{demographicSection('Applicant', {
                    sex: { female: "4193", male: "4194", doNotWish: "4195" },
                    ethnicity: {
                        doNotWish: "4245", notHispanic: "4211", hispanic: "4210",
                        mexican: "4144", puerto: "4145", cuban: "4146", hispanic2: "4147", print: "4125"
                    },
                    race: {
                        doNotWish: "4205", americanIndian: "1524", tribe: "4126",
                        asian: "1525", asianGroup: ["4148", "4149", "4150", "4151", "4152", "4153"],
                        otherAsian: "4154", print1: "4128",
                        black: "1526", nativeHawaiian: "1527",
                        pacificGroup: ["4155", "4156", "4157"], otherPacific: "4158", print2: "4130",
                        white: "1528"
                    }
                })}</div>

                <div>{demographicSection('Co-Applicant', {
                    sex: { female: "4197", male: "4198", doNotWish: "4199" },
                    ethnicity: {
                        doNotWish: "4248", notHispanic: "4214", hispanic: "4213",
                        mexican: "4159", puerto: "4160", cuban: "4161", hispanic2: "4162", print: "4136"
                    },
                    race: {
                        doNotWish: "4206", americanIndian: "1532", tribe: "4137",
                        asian: "1533", asianGroup: ["4163", "4164", "4165", "4166", "4167", "4168"],
                        otherAsian: "4169", print1: "4139",
                        black: "1534", nativeHawaiian: "1535",
                        pacificGroup: ["4170", "4171", "4172"], otherPacific: "4173", print2: "4141",
                        white: "1536"
                    }
                })}</div>
            </div>
        </div>
    );
};

export default ApplicantDemographics;
